import {
  StepperProps as MantineStepperProps,
  Stepper as MantineStepper,
  StepperStepProps as MantineStepperStepProps,
  StepperStep as MantineStepperStep,
  StepperCompletedProps as MantineStepperCompletedProps,
  StepperCompleted as MantineStepperCompleted,
} from '@mantine/core';

export type StepperProps = MantineStepperProps;
export type StepperStepProps = MantineStepperStepProps;
export type StepperCompletedProps = MantineStepperCompletedProps;

export const Stepper = MantineStepper;
Stepper.displayName = 'Stepper';

export const StepperStep = MantineStepperStep;
StepperStep.displayName = 'StepperStep';

export const StepperCompleted = MantineStepperCompleted;
StepperCompleted.displayName = 'StepperCompleted';
